<div style="background: #F5F5F5; padding: 16px;">
  <div class="row page-title-bar" style="margin-bottom: 16px;">
    <div class="medium-12 title">Clients List</div>
  </div>
  <div class="row" style="background: #FFFFFF;">
    <div class="column large-4 medium-4 small-4" style="font-size: 14px !important;margin: 15px 0 5px 0;">
      <div style="border: 1px solid #D0D5DD;border-radius: 4px;padding: 5px 14px;">
        <input (keyup.enter)="filterData()" (input)="onSearchInputChange()" [(ngModel)]="searchKey"
               placeholder="Search" style="border-bottom: none !important;margin-bottom: 0;" type="text"/>
      </div>
    </div>
    <div *ngIf="currentTab === 'Live Clients'" class="column large-8 medium-8 small-8"
         style="font-size: 14px !important;margin: 15px 0 5px 0;">
      <div (click)="showProtectedView()" class="pointer float-right"
           style="color: #667085;border: 1px solid #D0D5DD;border-radius: 4px;padding: 10px 14px">
        <i *ngIf="protectedView" class="material-icons manage-strategy-icon"
           style="font-size: 1.2rem;">visibility_off</i>
        <i *ngIf="!protectedView" class="material-icons manage-strategy-icon" style="font-size: 1.2rem;">visibility</i>
      </div>
      <div class="float-right" style="margin-right: 10px;">
          <span class="float-right text-left tasks-filter">
            <app-client-labels-search></app-client-labels-search>
          </span>
      </div>
      <div (click)="addNewUser()" class="float-right pointer"
           style="margin: 10px 10px;color: #1570EF;display: inline-flex;">
        <i class="material-icons">add</i><span style="position: relative;top: 2px;">Create a new Client</span>
      </div>
    </div>
  </div>
  <div *ngIf="currentTab === 'Live Clients' && searchFilters && searchFilters.length > 0" class="row"
       style="background: #FFFFFF;">
    <div class="column medium-12" style="font-size: 12px !important;color: #333333;margin: 15px 0;">Applied Filters:
      <span *ngFor="let search of searchFilters | slice:0:3; let i = index"
            style="padding: 5px;background: #EFF8FF;border-radius: 6px;color: #175CD3;font-size: 12px;margin:0 15px;">{{search.displayName}}:{{search.value}}
        <span class="pointer">
            <i (click)="removeSearchItem(search, i)" class="icon ion-close-round tag-remove"
               style="color: #2E90FA;font-size: 12px;"></i>
        </span>
      </span>
    </div>
  </div>
  <div class="d-flex justify-content-between" style="background: #FFFFFF;">
    <div class="d-flex mt-2 mb-2">
      <div (click)="selectClientsType('Live Clients')" [ngClass]="{'selected-tab' : currentTab === 'Live Clients'}"
           class="pointer clients-type-sec">Live Clients
      </div>
      <div (click)="selectClientsType('Draft Clients')" [ngClass]="{'selected-tab' : currentTab === 'Draft Clients'}"
           class="pointer clients-type-sec">Draft Clients
      </div>
    </div>
    <div class="mt-2 mb-2 pe-2">
      <div (click)="refreshListOfClients()" class="pointer clients-type-sec selected-tab">Refresh</div>
    </div>
  </div>
  <div class="row" *ngIf="currentTab === 'Draft Clients'" style="background: #FFFFFF; padding: 10px 15px 0 15px;">
    <div class="medium-12 column" style="margin-bottom: 10px;">
      <div class="row">
        <div class="medium-3 scenarios">
          <span style="font-size: 20px;font-weight: 500;color: #333333">Draft Clients</span>
          <span class="scenario-dropdown" style="display: inline-block;margin-left: 15px;" *ngIf="selectedDraftRows.length > 0">
            <label>
              <app-tpiq-select-dropdown
                [setData]="draftActions"
                [includeNone]="false"
                [setDefaultValue]="''"
                [setSearchKey]="'name'"
                [setPlaceHolder]="'Actions'"
                [setValueKey]="'name'"
                (onValueSelect)="applyDraftAction($event)">
              </app-tpiq-select-dropdown>
            </label>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row client-todos tax-planning-clients" style="background: #FFFFFF;padding-left: 0px;">
    <div class="column large-12 medium-12 small-12 clients-data" style="padding: 0;">
      <div class="indy-tables badge-tables tooltip-overflow dash-table">
        <app-tracker-paginated-table (onInputSearchSelection)="optionSelected($event)" (onRowAction)="handleAction($event)" (onRowClick)="handleRowSelect($event)" (onScroll)="handleScroll($event)"
                                     (onSort)="sortByColumn($event)" (onRowSelect)="handleDraftSelect($event)"
                                     *ngIf="hasUserList"
                                     [setObj]="userTableData"></app-tracker-paginated-table>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['addOrEditClient']">
  <div [ngClass]="{'tpiq-reveal': reveal['addOrEditClient']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['addOrEditClient']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">{{editMode ? 'Update Client' : 'Create a New Client'}} </span>
      <span (click)="hideReveal('addOrEditClient')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <app-create-or-update-client (onCancelCreateOrUpdateOfClient)="hideReveal('addOrEditClient')" (onCreationOrUpdateOfClient)="refreshListOfClients()"
                                   [clientId]="clientId"
                                   [editMode]="editMode"></app-create-or-update-client>
    </div>
  </div>
</div>

<div *ngIf="reveal['customStatus']">
  <div [ngClass]="{'tpiq-reveal': reveal['customStatus']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['customStatus']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 40%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Status of a Client</span>
      <span (click)="hideReveal('customStatus')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="medium-7">
          <label>
            Enter custom status:
            <input [(ngModel)]="clientCustomStatus" placeholder="Enter status" style="font-size: 1.0em !important;"
                   type="text"/>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns row-padding-reveal">
          <button (click)="updateCustomStatus()" class="button small float-right">Update</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['showConfirmation']">
  <div [ngClass]="{'tpiq-reveal': reveal['showConfirmation']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['showConfirmation']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Confirmation</span>
      <span (click)="hideReveal('showConfirmation')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <span>You are about to enable this client's Taxplan IQ portal and your client will get a welcome email notification. Do you want to continue?</span>
        </div>
      </div>
      <div class="row row-padding-reveal float-right">
        <button (click)="hideReveal('showConfirmation')" class="button small">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Core Focus create plan changes-->

<div *ngIf="reveal['createPlan']">
  <div [ngClass]="{'tpiq-reveal': reveal['createPlan']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['createPlan'], 'rap-maximized': isRapMaximized}" class="reveal tax-strategy-reveal"
       [style.width]="isRapMaximized ? 'calc(100vw - 20px)' : '83%'"
       [style.height]="isRapMaximized ? 'calc(100vh - 20px)' : 'auto'"
       [style.top]="isRapMaximized ? '10px' : '25px'"
       [style.left]="isRapMaximized ? '50%' : '50%'"
       [style.right]="isRapMaximized ? null : null"
       [style.transform]="isRapMaximized ? 'translateX(-50%)' : 'translateX(-50%)'"
       [style.max-height]="isRapMaximized ? 'calc(100vh - 20px)' : 'calc(100vh - 50px)'"
       style="padding: 0; border: none;">
    <div style="padding: 15px; color: #333333; display: flex; justify-content: flex-end; align-items: center; gap: 10px;">
      <i class="material-icons pointer" 
         [title]="isRapMaximized ? 'Restore' : 'Maximize'"
         (click)="toggleRapMaximize()"
         style="font-size: 20px; cursor: pointer; padding: 0 2px;">
        {{isRapMaximized ? 'fullscreen_exit' : 'fullscreen'}}
      </i>
      <span (click)="hideReveal('createPlan')" class="pointer" style="font-size: 20px; cursor: pointer; line-height: 1;">X</span>
    </div>
    <div class="body">
      <app-dashboard-upload-create-plan (onCancelCreationOfStrategy)="closeCoreFocusPopup($event)" (onCommitSuccess)="closeCoreFocusPopup($event)" [clientId]="clientId"
                                        [documentId]="draftClientDocId" [draftPlanId]="draftPlanId"
                                        [isReviewPlan]="isReviewPlan" [ocrStatus]="ocrStatus"
                                        [planName]="draftClientPlanName"
                                        [tabToLand]="tabNameToLand" (openViewJsonPopup)="reveal['viewJson'] = true" (ocrDataReceived)="handleOcrData($event)" (openView1040PdfPopup)="reveal['view1040PDF'] = true" [chatId] = "chatId" [questionnaireTrack] = "questionnaireTrack" (updateQuestionarieData)="handleQuestionarieData($event)" (openViewQuestionariePopup)="reveal['viewQuestionarieDetails'] = true" [isRapMaximized]="isRapMaximized" [questionnaireUtilization]="questionnaireUtilization"></app-dashboard-upload-create-plan>
    </div>
  </div>
</div>
  <!-- Second Popup -->
<div *ngIf="reveal['viewJson']">
  <div [ngClass]="{'tpiq-reveal': reveal['viewJson']}" class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 83%; z-index: 1100; height: 100%; max-height: calc(100vh - 50px);">
    <div style="padding: 15px; color: #333333;">
      <span (click)="hideReveal('viewJson')" class="float-right pointer">X</span>
    </div>
    <div class="body" style="padding: 15px;  max-height: 90vh; overflow-y: auto" >
     <div *ngIf="ocrViewJsonData">
      <h6>OCR Data:</h6>
      <pre>{{ ocrViewJsonData ? (ocrViewJsonData | json) : 'No data yet' }}</pre>
    </div>
    <div *ngIf="!ocrViewJsonData">
      <h6>OCR Data Not Found</h6>
    </div>
  </div>
</div>
</div>
<div *ngIf="reveal['view1040PDF']">
  <div [ngClass]="{'tpiq-reveal': reveal['view1040PDF']}" class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 83%; z-index: 1100; height: 100%; max-height: calc(100vh - 50px);">
    <div style="padding: 15px; color: #333333;">
      <span (click)="hideReveal('view1040PDF')" class="float-right pointer">X</span>
    </div>
    <div class="body" style="padding: 15px;  max-height: 90vh; overflow-y: auto" >
     <div>
      <h6>Document Details: {{draftClientDocId}} | {{draftClientDocumentName}} </h6>
    </div>
  </div>
</div>
</div>
<div *ngIf="reveal['viewQuestionarieDetails']">
  <div [ngClass]="{'tpiq-reveal': reveal['viewQuestionarieDetails']}" class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 83%; z-index: 1100; height: 100%; max-height: calc(100vh - 50px);">
    <div style="padding: 15px; color: #333333;">
      <span (click)="hideReveal('viewQuestionarieDetails')" class="float-right pointer">X</span>
    </div>
    <div class="body" style="padding: 15px;  max-height: 90vh; overflow-y: auto" >
     <div>
      <h6>OCR data from last knoli session:</h6>
      <pre>{{ questionarieData && questionarieData.ocrData ? (questionarieData.ocrData | json) : 'New Json not avaiable as Questionarie details not submitted' }}</pre>
      <a *ngIf="questionarieData && questionarieData.chatId" href="{{currentEnvironment.KNOLLI_CHAT_URL}}/admin/workspaces/1505/copilots/1523/edit/conversations/{{questionarieData.chatId}}" target="_blank">Click here to view coversation details on knolli</a>
    </div>
  </div>
</div>
</div>
